let globalIdCounter = 0;

export const getUniqueId = (): string => {
    globalIdCounter++;
    return `uic-unique-id-${globalIdCounter}`;
};
